import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

function ChargeIcon(props) {
  return (
    <SvgIcon viewBox="0 0 18 18" {...props}>
      <g clipPath="url(#clip0_1427_49814)">
        <path
          d="M10.7757 1.69531L3.46875 10.0461H8.16608L6.6003 16.3092L13.9073 7.95842H9.20993L10.7757 1.69531Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1427_49814">
          <rect
            width="16.7016"
            height="16.7016"
            fill="white"
            transform="translate(0.335938 0.648438)"
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}

export default ChargeIcon;
